import script from "./SkeletonGroupList.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonGroupList.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonGroupList.vue?vue&type=style&index=0&id=9372788c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9372788c"]])

export default __exports__